import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import * as React from 'react';
const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
function Label({ className, ref, ...props }) {
    return _jsx(LabelPrimitive.Root, { ref: ref, className: cn(labelVariants(), className), ...props });
}
export { Label };
